import WritingStyles from "./Writing.module.css"
import BordersStyles from './Borders.module.css';
import OpenBookCover from "./photos/BookDecorWebP/BookofAbdul_BookCover.webp";
import FrontBookCover from "./photos/BookDecorWebP/BookofAbdul_FrontBookCover.webp";
import BackBookCover from "./photos/BookDecorWebP/BookofAbdul_BackBookCover.webp";
import IndividualPage from "./photos/BookDecorWebP/BookofAbdul_Pages(Individual).webp";
import SigilDec from "./photos/BookDecorWebP/BookofAbdul_SigilDecoration.webp"
import ImageDec1 from "./photos/BookDecorWebP/BookofAbdul_ImageBorder2.webp" 
import { WritingLayout } from './Borders';
import { HeaderElement } from "./Header";

function Writing() {
    const open = 
        {
            title: "OpenBookCover",
            photo: OpenBookCover,
            id: 1
        };

    const page = 
        {
            title: "IndividualPage",
            photo: IndividualPage,
            id: 2
        };  

    const decs = 
        {
            title: "SigilDecoration",
            photo: SigilDec,
            id: 3
        };

    const imgborder = 
        {
            title: "ImageBorder1",
            photo: ImageDec1,
            id: 4
        };

    const front = 
        {
            title: "FrontBookCover",
            photo: FrontBookCover,
            id: 5
        };

    const back = 
        {
            title: "BackBookCover",
            photo: BackBookCover,
            id: 6
        };

    const pagenums = 13;
    
    // Trick to make animation play only on header click.
    let value = false;
    if (HeaderElement.GetHeader === "BoA-header-writing") {
        value = true;
    }
    console.debug("Test value? " + value);

    return (
        <section className="Book-of-Abdul-Book-Placement">
            <div id="BoA-book-cover-open">
                <img id="BoA-open-img" src={open.photo} alt={open.title}/>
            </div>
            <div id="BoA-book-cover-front" style={{opacity: "0.0"}}>
                <img id="BoA-front-img" src={front.photo} alt={front.title}/>  
            </div>
            <div id="BoA-book-cover-back" style={{opacity: "0.0"}}>
                <img id="BoA-back-img" src={back.photo} alt={back.title}/>  
            </div>
            <div className="BoA-background-pages" id="BoA-background-pages">
                <ul className={WritingStyles["BoA-individual-pages"]} value={value}>
                    {[...Array(pagenums)].map((e, i) => (
                        <li className={"BoA-Writepage-" + i} key={i}>
                            <img className="BoA-page-img" src={page.photo} alt={page.title} key={e}/>
                        </li>
                    ))}
                </ul>
            </div>
            <div className={BordersStyles["BoA-page-content"]} id="BoA-page-content" style={{zIndex: "9"}}>                
                <WritingLayout
                section="Writing"
                img1={SigilDec} 
                alt1={decs.title}
                img2={ImageDec1}
                alt2={imgborder.title}/>
            </div>
        </section>
    );
}

export default Writing;